module.exports = __webpack_public_path__ + "static/media/34.3ae61bff.jpg";